import { ReactNode } from "react";
import useScreenSize from "@hooks/useScreenSize";
import { IconScreen } from "@ucchub/ui";
import styled from "styled-components";

export interface ResProps {
  children: ReactNode;
}

const CenterContentWrapper = styled.div`
  margin: 0 auto;
`;

const ResolutionScreen = ({ children }: ResProps) => {
  const { winWidth } = useScreenSize();

  if (winWidth < 1024) {
    return (
      <CenterContentWrapper id="screenRes">
        <IconScreen
          title="This application is not supported on this device"
          description="It appears that your screen resolution is below the needed system requirement.
                                 The minimum supported screen resolution for this application
                        is 1024 x 768 pixels."
          group="hifiDark"
          appearance="secondary"
        />
      </CenterContentWrapper>
    );
  } else {
    return <CenterContentWrapper>{children}</CenterContentWrapper>;
  }
};

export default ResolutionScreen;
